// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1N05J","bigColWidth":"Table_bigColWidth__3Yjos","biggerColWidth":"Table_biggerColWidth__2zZP0","row":"Table_row__DhDP7","col":"Table_col__sP6_f"};